import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import _get from 'lodash/get';
import React from 'react';
import { useSelector } from 'react-redux';
import classes from './WhoCanSee.module.css';

const WhoCanSeeUser = ({ userId }) => {
  const { signedInAs, postingAs } = useSelector((state) => state.user);
  let managedProfile = false;
  let viewer = useSelector((state) => (_get(state, 'user.signedInAs.KnownUsers', []).find((user) => user.User.UserId === userId) || {}).User);
  if (signedInAs.UserId === userId) {
    viewer = signedInAs;
  } else if (postingAs.UserId === userId) {
    viewer = postingAs;
    managedProfile = true;
  } else if (viewer) {
    managedProfile = !!viewer.ManagedBy;
  }
  if (!viewer) return null;
  return <p className={classes.Viewer}>{`${viewer.FullName} ${managedProfile ? '*' : ''}`}</p>;
};

const whoCanSee = (props) => {
  return (
    <div className={classes.WhoCanSeeContainer}>
      <h2>Who can see this?</h2>
      <FontAwesomeIcon icon="times-circle" className={classes.CloseIcon} onClick={props.close} />
      {props.viewers.map((viewer) => (
        <WhoCanSeeUser key={viewer.UserId} userId={viewer.UserId} />
      ))}
    </div>
  );
};

export default whoCanSee;
